import { parseDate } from '../helpers/parse-date';

const costs = {
  'Start Date': {
    requirementType: 'optional',
    description: 'Start date of the task in "YYYY-MM-DD" or "MM/DD/YYYY" format.',
    dataType: 'date',
    validator: (value) => {
      const startDate = parseDate(value);
      return !!startDate || !value;
    },
  },
  'Member Email': {
    requirementType: 'required',
    description: 'Provide the email address associated with the workspace member.',
    dataType: 'email',
    validator: (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value),
  },
  'Cost Per Period': {
    requirementType: 'optional',
    description: 'Cost value per period based on cost method.',
    dataType: 'number',
    validator: (value) => {
      return !value || (!isNaN(parseFloat(value)) && isFinite(value) && Number(value) >= 0);
    },
  },

  'Overhead Cost Per Period': {
    requirementType: 'optional',
    description: 'Overhead cost value per period based on cost method.',
    dataType: 'number',
    validator: (value) => {
      return !value || (!isNaN(parseFloat(value)) && isFinite(value) && Number(value) >= 0);
    },
  },

  Currency: {
    requirementType: 'optional',
    description:
      'Provide a valid 3-letter ISO currency code (for example: USD, EUR, GBP). Leave blank to use the member default currency; if none is set, the workspace default currency will be applied.',
    dataType: 'string',
    validator: (value) => {
      if (!value) return false;
      const cleaned = value.trim().toUpperCase();
      return /^[A-Z]{3}$/.test(cleaned);
    },
  },

  'Cost Method': {
    requirementType: 'optional',
    description:
      'Provide a value of "hourly", "fixed_hourly" or "fixed_monthly" for the cost method. "fixed_hourly" will be used by default.',
    dataType: 'string',
    validator: (value) => ['hourly', 'fixed_hourly', 'fixed_monthly'].includes(value.trim().toLowerCase()),
  },
};

export default costs;
